import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./stories.css";

import allPosts from "../../content/blog/posts.generated.json";

// Full "life story" feed for the About Me page: every post, newest first,
// each with its image, title, date/place and full text. Alternates the image
// side for a timeline-like rhythm.
const Stories = ({ posts }) => {

    const stories = posts || allPosts;

    return (
        <div className="stories">
            {
                stories.map((s, idx) => (
                    <div
                        key={s.slug}
                        className={idx % 2 === 0 ? "story" : "story flipped-order"}
                    >
                        <div className="story-image">
                            <img src={s.image} alt={s.title}></img>
                        </div>
                        <div className="story-body">
                            <p className="story-title">{s.title}</p>
                            <span className="story-place">{s.place}</span>
                            {s.place && ", "}
                            <span className="story-date">{s.date}</span>
                            <div className="story-text">
                                <ReactMarkdown remarkPlugins={[remarkGfm]}>{s.body}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};

export default Stories;
